<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "primary-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 17 18">
    <path
      d="M11.5297 5.60872H8.00441C6.60197 5.60872 5.25697 6.16584 4.26529 7.15751C3.27361 8.14919 2.7165 9.49419 2.7165 10.8966C2.7165 12.2991 3.27361 13.6441 4.26529 14.6358C5.25697 15.6274 6.60197 16.1845 8.00441 16.1845H10.6484C11.1351 16.1845 11.5297 16.5791 11.5297 17.0659V17.0659C11.5297 17.5526 11.1351 17.9472 10.6484 17.9472H8.00441C6.13449 17.9472 4.34115 17.2044 3.01892 15.8821C1.69668 14.5599 0.953857 12.7666 0.953857 10.8966C0.953857 9.02671 1.69668 7.23337 3.01892 5.91114C4.34115 4.5889 6.13449 3.84608 8.00441 3.84608H11.5297V1.36915C11.5297 0.952845 12.0152 0.725425 12.3351 0.991938L16.365 4.35019C16.6005 4.54649 16.6005 4.9083 16.3649 5.10461L12.3351 8.46286C12.0152 8.72937 11.5297 8.50195 11.5297 8.08564V5.60872Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
